<template>
  <v-app-bar
    hide-on-scroll
    elevate-on-scroll
    scroll-threshold="100"
    color="white"
    height="96px"
    app
  >
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="58px"
          />
        </router-link>

        <div class="d-flex align-center">
          <template v-for="({ text, link, icon, size }, keySocial) in social">
            <v-btn
              :key="keySocial"
              color="white"
              :href="link"
              target="_blank"
              :title="text"
              height="40px"
              width="40px"
              depressed
              fab
            >
              <v-icon color="grey darken-2" :size="size">
                {{ icon }}
              </v-icon>
            </v-btn>
          </template>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>
